var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Facebook_White",
    "data-name": "Facebook/White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.307,
    height: 22.307,
    viewBox: "0 0 22.307 22.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Facebook",
    d: "M11.915,22.307H1.231A1.231,1.231,0,0,1,0,21.076V1.231A1.231,1.231,0,0,1,1.231,0H21.076a1.231,1.231,0,0,1,1.231,1.231V21.076a1.231,1.231,0,0,1-1.231,1.231H15.391V13.668h2.9l.434-3.367H15.391V8.153c0-.975.271-1.639,1.668-1.639h1.783V3.5a23.831,23.831,0,0,0-2.6-.133c-2.57,0-4.33,1.569-4.33,4.45V10.3H9.008v3.367h2.907v8.638Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.863cc776257dcd62c4483a436b96313c.svg";
export { ForwardRef as ReactComponent };